import Vue from 'vue'
import Vuex from 'vuex'
import 'moment/locale/ja'
import moment from 'moment'
import createPersistedState from 'vuex-persistedstate'

let getUrlParameter = function getUrlParameter (sParam) {
  let sPageURL = window.location.search.substring(1)
  let sURLVariables = sPageURL.split('&')
  let sParameterName
  let i

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=')

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
    }
  }
  return false
}

const initialState = function () {
  let defaultDate = moment()
  let newTime = 't' + defaultDate.format('HHmm')
  var over = false
  var xhr = new XMLHttpRequest()
  let int = getUrlParameter('int')
  var url = '/api/getLimit.json?int=' + int
  let subdomain = location.host.split('.')[0]

  if (location.hostname === 'localhost' || location.port === '8080') {
    if (subdomain.match(/^[a-z]+$/)) {
      url = 'https://' + subdomain + '.stgsgs.com/reserve/api/getLimit.json?int=' + int
    } else {
      url = 'https://tkssp.stgsgs.com/reserve/api/getLimit.json?int=' + int
    }
  }
  xhr.open('GET', url, false) // trueで非同期
  xhr.onload = function (e) {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        var limit = moment(xhr.responseText, 'HH:mm:ss')
        over = defaultDate.hours() >= limit.hours()
        if (limit.minutes() !== 0 && defaultDate.hours() === limit.hours()) {
          over = defaultDate.minutes() >= limit.minutes()
        }
      } else {
        console.error(xhr.statusText)
      }
    }
  }
  xhr.send(null)
  if (over) {
    defaultDate = defaultDate.add(1, 'days')
    newTime = ''
  }
  var defaultState = {
    userId: 1,
    memberLimit: 6,
    isCRMMember: false,
    isCRMRepeater: false,
    crm_id: '',
    step: 1,
    loadedMembership: false,
    rentalDate: defaultDate.format('YYYY/MM/DD'),
    rentalDateY: defaultDate.format('YYYY'),
    rentalDateM: defaultDate.format('MM'),
    rentalDateD: defaultDate.format('DD'),
    willVisit: newTime,
    tel: '',
    email: '',
    country: 'JP',
    address1: '',
    address2: '',
    email_retype: '',
    // idcard: 'M',
    idcard: 'D',
    privacy: '',
    reserve_term: '01',
    zip: '',
    address: '',
    type: '',
    reserveId: '',
    reserveIdShort: '',
    reserveIdRow: '',
    myPageHash: '',
    lang: 'ja',
    members: [],
    currentDay: defaultDate.format('YYYYMMDD'),
    fee: 0,
    publicKey: '',
    selectOptions: [],
    optionValues: {},
    saveMembership: true,
    custCode: '',
    locked: {},
    introduceCode: null,
    paymentType: null
  }
  if (subdomain === 'tkssp') {
    defaultState.saveMembership = false
  }
  return defaultState
}

moment.locale('ja')
Vue.use(Vuex)
export default new Vuex.Store({
  state: initialState(),
  mutations: {
    update (state, obj) {
      state[obj.field] = obj.value
    },
    initState (state) {
      let init = initialState
      Object.assign(state, init)
    },
    viewState (state, newState) {
      Object.assign(state, newState)
    }
  },
  actions: {},
  modules: {},
  methods: {},
  plugins: [createPersistedState({ key: 'rakuraku-rental2025', storage: window.sessionStorage })]
})
